var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2H16C20.4183 2 24 5.58172 24 10V16C24 20.4183 20.4183 24 16 24H10C5.58172 24 2 20.4183 2 16V10C2 5.58172 5.58172 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0H16C21.5228 0 26 4.47715 26 10V16C26 21.5228 21.5228 26 16 26H10C4.47715 26 0 21.5228 0 16V10ZM12.3902 10.0914L12.2481 20.5459H14.1799L14.0379 10.0914H12.3902ZM14.116 6.26325C13.8651 6.01231 13.5644 5.88683 13.214 5.88683C12.9773 5.88683 12.7642 5.94365 12.5748 6.05729C12.3807 6.17566 12.2268 6.33191 12.1132 6.52604C11.9948 6.72017 11.9356 6.93323 11.9356 7.16524C11.9356 7.51562 12.0611 7.81628 12.312 8.06723C12.563 8.31818 12.8637 8.44365 13.214 8.44365C13.5644 8.44365 13.8651 8.31818 14.116 8.06723C14.367 7.81628 14.4924 7.51562 14.4924 7.16524C14.4924 6.81486 14.367 6.5142 14.116 6.26325Z",
    fill: "#1A1A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e51e4f9a637a8cf8f2fa9b6acfe53f89.svg";
export { ForwardRef as ReactComponent };